import { Switch, Route } from "react-router-dom";
import ClientesListaPage from "./Listagem";
import ClientesDetalhesPage from "./Detalhes";

function ClientePages() {
  return (
    <Switch>
      <Route exact path="/cadastros/clientes" component={ClientesListaPage} />
      <Route
        exact
        path="/cadastros/clientes/novo"
        component={ClientesDetalhesPage}
      />
      <Route
        exact
        path="/cadastros/clientes/:id"
        component={ClientesDetalhesPage}
      />
    </Switch>
  );
}

export default ClientePages;
